import { render, staticRenderFns } from "./app.empty.vue?vue&type=template&id=6cf56dc9&"
import script from "./app.empty.vue?vue&type=script&lang=js&"
export * from "./app.empty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports